"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CoverPlaceholder;

var _element = require("@wordpress/element");

var _blockEditor = require("@wordpress/block-editor");

var _i18n = require("@wordpress/i18n");

var _icons = require("@wordpress/icons");

var _shared = require("../shared");

/**
 * WordPress dependencies
 */

/**
 * Internal dependencies
 */
function CoverPlaceholder(_ref) {
  let {
    disableMediaButtons = false,
    children,
    onSelectMedia,
    onError,
    style
  } = _ref;
  return (0, _element.createElement)(_blockEditor.MediaPlaceholder, {
    icon: (0, _element.createElement)(_blockEditor.BlockIcon, {
      icon: _icons.cover
    }),
    labels: {
      title: (0, _i18n.__)('Cover'),
      instructions: (0, _i18n.__)('Drag and drop onto this block, upload, or select existing media from your library.')
    },
    onSelect: onSelectMedia,
    accept: "image/*,video/*",
    allowedTypes: _shared.ALLOWED_MEDIA_TYPES,
    disableMediaButtons: disableMediaButtons,
    onError: onError,
    style: style
  }, children);
}
//# sourceMappingURL=cover-placeholder.js.map